var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        "custom-class": "bussiness-info-dialog",
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.AssociationBusinessInformation"),
        "close-on-click-modal": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: function($event) {
          _vm.innerVisible = false
        }
      }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _vm.showRevokeButton
          ? _c(
              "div",
              { staticStyle: { "padding-bottom": "5px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { no: "revoke", type: "danger" },
                    on: { click: _vm.revokeJobHandler }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_WithdrawTheEntrustment"))
                    )
                  ]
                )
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          {
            class:
              "tabs-container" +
              (_vm.canOperateJob ? "" : " cannot-operate-job")
          },
          [
            _c("span", { staticClass: "lab-state" }, [
              _vm._v(_vm._s(_vm.labState))
            ]),
            _c(
              "el-tabs",
              {
                ref: "tabs",
                attrs: { type: "card" },
                on: { "tab-click": _vm.handleTabClick },
                model: {
                  value: _vm.activeTabName,
                  callback: function($$v) {
                    _vm.activeTabName = $$v
                  },
                  expression: "activeTabName"
                }
              },
              [
                !_vm.isRe && _vm.currentRow && !_vm.currentRow.masterFlag
                  ? _c(
                      "el-tab-pane",
                      {
                        key: 101,
                        attrs: {
                          name: "tabBookingFCL",
                          label: _vm.$t("SeaExport.Basic")
                        }
                      },
                      [
                        _c("tab-booking-fcl", {
                          ref: "tabBookingFCL",
                          attrs: {
                            "slave-customs-declaration-enable":
                              _vm.slaveCustomsDeclarationEnable,
                            context: _vm.context,
                            action: _vm.action
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.isRe
                  ? _c(
                      "el-tab-pane",
                      {
                        key: 103,
                        attrs: {
                          name: "tabVesselEq",
                          label: _vm.$t("SeaExport.Booking")
                        }
                      },
                      [
                        _c("tab-vessel-eq", {
                          ref: "tabVesselEq",
                          attrs: {
                            context: _vm.context,
                            action: _vm.action,
                            "show-button": _vm.showButton
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.isRe && !_vm.isCrossTenantSeToSi
                  ? _c(
                      "el-tab-pane",
                      {
                        key: 104,
                        attrs: {
                          name: "tabSpecialGoods",
                          label: _vm.$t("SpecialGoods.label")
                        }
                      },
                      [
                        _c("tab-special-goods", {
                          ref: "tabSpecialGoods",
                          attrs: { context: _vm.context, action: _vm.action }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.isRe && !_vm.isCrossTenantSeToSi
                  ? _c(
                      "el-tab-pane",
                      {
                        key: 105,
                        attrs: {
                          name: "tabSopState",
                          label: _vm.$t("SeaExport.BusinessStatus")
                        }
                      },
                      [
                        _vm.$checkPermission(["tab_SEBooking_portalState"])
                          ? _c("tab-sop-state", {
                              ref: "tabSopState",
                              attrs: {
                                context: _vm.context,
                                action: _vm.action,
                                "show-button": _vm.showButton
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.isRe && !_vm.isCrossTenantSeToSi
                  ? _c(
                      "el-tab-pane",
                      {
                        key: 106,
                        attrs: {
                          name: "tabFileHistory",
                          label: _vm.$t("SeaExport.FileHistory")
                        }
                      },
                      [
                        _c("tab-file-history", {
                          ref: "tabFileHistory",
                          attrs: {
                            context: _vm.context,
                            action: _vm.action,
                            "show-button": _vm.showButton,
                            "can-operate-job": _vm.canOperateJob,
                            "view-source": "trustFromWindow"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.isRe && _vm.currentRow && !_vm.currentRow.masterFlag
                  ? _c(
                      "el-tab-pane",
                      {
                        key: 101,
                        attrs: {
                          name: "tabBookingFCLRe",
                          label: _vm.$t("SeaExport.Basic")
                        }
                      },
                      [
                        _c("tab-booking-fcl-re", {
                          ref: "tabBookingFCLRe",
                          attrs: { context: _vm.context, action: _vm.action }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.isRe && _vm.$checkPermission(["tab_REBooking_portalState"])
                  ? _c(
                      "el-tab-pane",
                      {
                        key: 105,
                        attrs: {
                          name: "tabSopStateRe",
                          label: _vm.$t("SeaExport.BusinessStatus")
                        }
                      },
                      [
                        _c("tab-sop-state", {
                          ref: "tabSopStateRe",
                          attrs: {
                            context: _vm.context,
                            action: _vm.action,
                            "show-button": _vm.showButton
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.isRe
                  ? _c(
                      "el-tab-pane",
                      {
                        key: 106,
                        attrs: {
                          name: "tabFileHistoryRe",
                          label: _vm.$t("SeaExport.FileHistory")
                        }
                      },
                      [
                        _c("tab-file-history", {
                          ref: "tabFileHistoryRe",
                          attrs: {
                            context: _vm.context,
                            action: _vm.action,
                            "show-button": _vm.showButton,
                            "can-operate-job": _vm.canOperateJob,
                            "view-source": "trustFromWindow"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }